import { render, staticRenderFns } from "./FimalacProject.vue?vue&type=template&id=6b8a56e2&scoped=true&"
import script from "./FimalacProject.vue?vue&type=script&lang=js&"
export * from "./FimalacProject.vue?vue&type=script&lang=js&"
import style0 from "./FimalacProject.vue?vue&type=style&index=0&id=6b8a56e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8a56e2",
  null
  
)

export default component.exports